import { SET_MANUAL_ENTRY_EDIT_DATA, CLEAR_MANUAL_ENTRY_EDIT_DATA } from '../actions/actionTypes';

import ManualEntryEdit from '../../models/ManualEntryEdit';

const initialState: ManualEntryEdit = { } as ManualEntryEdit;

export const manualEntryEditReducer = (state = initialState, action: any) => {

  switch (action.type) {

    case SET_MANUAL_ENTRY_EDIT_DATA:
      return {
        ...state,
        isEditMode: action.data.isEditMode,
        driverData: { ...state.driverData,
                      driverId: action.data.driverData.driverId,
                      driverIdType: action.data.driverData.driverIdType,
                      name: action.data.driverData.name,
                      company: action.data.driverData.company,
                      truckPlateNumber: action.data.driverData.truckPlateNumber,
                      rfsNumber: action.data.driverData.rfsNumber,
                      driverTime: action.data.driverData.driverTime
                    },
        forwarderId: action.data.forwarderId,
        dockId:  action.data.dockId,
        orderNumber:  action.data.orderNumber,
        orderId: action.data.orderId,
        isInterline: action.data.isInterline,
        isRfs: action.data.isRfs
      }
    case CLEAR_MANUAL_ENTRY_EDIT_DATA:
      return initialState;
    default:
      return state;
  }

};
